import { Timestamp } from 'firebase/firestore'
import moment from 'moment'

export const formatDateFull = (timestamp: Timestamp) => {
  const date = moment(timestamp.toDate())
  const day = date.date()
  const month = date.format('MMM')
  const year = date.year()

  const daySuffix = (day: number) => {
    if (day > 3 && day < 21) return 'th'
    switch (day % 10) {
      case 1:
        return 'st'
      case 2:
        return 'nd'
      case 3:
        return 'rd'
      default:
        return 'th'
    }
  }

  return `${day}${daySuffix(day)} ${month} ${year}`
}

export const formatDateMonth = (timestamp: Timestamp) => {
  const date = moment(timestamp.toDate())
  return date.format('MMM YYYY')
}

/**
 * Format a date string (YYYY-MM-DD) or a Firestore Timestamp into
 * a human readable string with ordinal day (e.g. '30th May 2025').
 */
export const formatDateString = (dateInput?: string | Timestamp | null) => {
  if (!dateInput) return ''

  let m
  if (typeof dateInput === 'string') {
    // parse as YYYY-MM-DD (safe)
    m = moment(dateInput, 'YYYY-MM-DD')
  } else {
    m = moment(dateInput.toDate())
  }

  if (!m.isValid()) return ''

  const day = m.date()
  const month = m.format('MMM')
  const year = m.year()

  const daySuffix = (d: number) => {
    if (d > 3 && d < 21) return 'th'
    switch (d % 10) {
      case 1:
        return 'st'
      case 2:
        return 'nd'
      case 3:
        return 'rd'
      default:
        return 'th'
    }
  }

  return `${day}${daySuffix(day)} ${month} ${year}`
}

/**
 * Format a date string (YYYY-MM-DD) or a Firestore Timestamp into
 * a month/year string (e.g. 'Jun 2023').
 */
export const formatDateMonthString = (
  dateInput?: string | Timestamp | null
) => {
  if (!dateInput) return ''

  let m
  if (typeof dateInput === 'string') {
    m = moment(dateInput, 'YYYY-MM-DD')
  } else {
    m = moment(dateInput.toDate())
  }

  if (!m.isValid()) return ''

  return m.format('MMM YYYY')
}
